module.exports = __webpack_public_path__ + "img/T2D_rc_23.9dc04197.png";